<template>
  <div>
    <!-- Data objects table -->
    <div v-if="isGranted([permissions.SYSTEM_DATA_OBJECT_VIEW, permissions.SYSTEM_DATA_OBJECT_VIEW_OWN], system)"
         class="card pagination-margin"
         qid="data-objects-section"
         id="update_data_objects"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-4">
            <h5 class="mb-2" qid="do-table-title" v-if="!showOnTask">
              {{ $t('systems.data_objects.title') }}
            </h5>

            <span v-if="!showOnTask">
              <span class="cursor-pointer task-label-open mr-2"
                    v-if="getTask('update_data_objects')"
              >
                <UpdateSingleTaskModal
                    :task="getTask('update_data_objects')"
                    @reloadContent="reloadContent"
                    :editIcon="true"
                ></UpdateSingleTaskModal>
              </span>
              <span v-if="getGuide('update_data_objects')">
                <GuideButton :guide="getGuide('update_data_objects')"></GuideButton>
              </span>
            </span>
          </div>
          <div class="col-sm-8 text-right">
            <span class="btn btn-success float-right"
                  @click="showCreateDOModal"
                  qid="system-do-create-button"
                  v-if="isGranted([permissions.SYSTEM_DATA_OBJECT_CREATE, permissions.SYSTEM_DATA_OBJECT_CREATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('systems.data_objects.create_button') }}
            </span>
            <span class="float-right" v-if="isGranted(permissions.DATA_OBJECT_CREATE) && (!getClient.parent || (getClient.parent && system.partition))"
                  qid="do-create-button"
            >
              <DataObjectCreateForm></DataObjectCreateForm>
            </span>
            <b-form-input
                type="text"
                v-model="keywordValue"
                class="float-right mw-300 mr-3 search-bar"
                v-on:input="debounceInput"
                :placeholder="$t('maintenance.data_objects.search_placeholder')"
                qid="do-search-input"
            ></b-form-input>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
            <tr>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('name')"
                  qid="do-sort-name"
              >
                {{ $t('maintenance.data_objects.table.name') }}
                <span class="ml-2">
                <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
              </span>
              </th>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('category')"
                  qid="do-sort-category"
              >
                {{ $t('maintenance.data_objects.table.category') }}
                <span class="ml-2">
                <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'category'"/>
                <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'category'"/>
                <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'category'"/>
              </span>
              </th>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('classification')"
                  qid="do-sort-classification"
              >
                {{ $t('maintenance.data_objects.table.classification') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'classification'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'classification'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'classification'"/>
                </span>
              </th>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('business_classification')"
                  qid="do-sort-classification"
              >
                {{ $t('maintenance.data_objects.table.business_classification') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'business_classification'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'business_classification'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'business_classification'"/>
                </span>
              </th>
              <th scope="col">
                {{ $t('systems.data_objects.table.mapped_to_activity') }}
              </th>
              <th scope="col">
                {{ $t('systems.data_objects.table.tags') }}
              </th>
              <th scope="col">
                {{ $t('table.last_updated') }}
              </th>
              <th width="130"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="object in DOTableItems">
              <td>
                <span @click="openViewDataModal(object)" class="btn btn-link cursor-pointer text-left">
                  {{ object.data_object.name }}
                </span>
              </td>
              <td>
                <span v-if="object.data_object.category">
                  <span class="badge" :title="object.data_object.category">
                    <font-awesome-icon icon="shapes"/>
                    {{ object.data_object.category | truncate(35) }}
                  </span>
                </span>
              </td>
              <td>
                <span v-if="object.data_object.classification">
                  <span class="badge">
                    {{ $t('classification.' + $options.filters.slugify(object.data_object.classification)) }}
                  </span>
                </span>
              </td>
              <td>
                <span v-if="object.data_object.business_classification">
                  <span class="badge">
                    {{ $t('classification.' + $options.filters.slugify(object.data_object.business_classification)) }}
                  </span>
                </span>
              </td>
              <td>
                <span class="text-normal">
                  <span v-if="object.activity_count">
                    <span class="badge-pill badge-success mr-2" >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span
                        @click="openViewDataObjectActivitiesModal(object)"
                        class="btn btn-link text-success btn-sm text-left cursor-pointer"
                    >
                      <span v-if="object.activity_count > 1">
                        {{ object.activity_count }} {{ $t('activities.title') | lowerCase }}
                      </span>
                      <span v-if="object.activity_count == 1">
                        {{ object.activity_count }} {{ $t('activities.log.title') | lowerCase}}
                      </span>
                    </span>
                  </span>
                  <span v-if="!object.activity_count">
                    <font-awesome-icon icon="times-circle" class="icon-danger"/>
                    {{ $t('system.no') }}
                  </span>
                </span>
              </td>
              <td>
                <span class="mr-1" v-for="tag in object.data_object.tags_translated" qid="p-tags-list">
                  <span class="badge" :title="tag.name_translated">
                    <font-awesome-icon icon="tag"/>
                    {{ tag.name_translated | truncate(35) }}
                  </span>
                </span>
              </td>
              <td class="text-normal">
                {{ object.updated_at | formatDate }}
              </td>
              <td align="right">
                <span @click="openViewDataModal(object)" class="btn btn-view">
                  <font-awesome-icon icon="eye"/>
                </span>

                <span class="btn btn-delete"
                      qid="delete-do-modal"
                      @click="showDOConfirmDeleteModal(object)"
                      v-if="!object.activity_count && isGranted([permissions.SYSTEM_DATA_OBJECT_DELETE, permissions.SYSTEM_DATA_OBJECT_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!DOLoading && !DOTableItems.length" qid="do-no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-body">
        <div class="pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="perPage"
                    :options="perPageOptions"
                    track-by="value"
                    label="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-org-form-organization-level"
                    @select="perPageChanged"
                    :placeholder="selectedPerPage"
                    @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- Delete data object modal template -->
    <b-modal ref="delete-data-object" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-do-title">
          {{ $t('systems.data_objects.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('systems.data_objects.delete.description') }}
        <span v-if="itemToDelete.data_object">{{ itemToDelete.data_object.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('systems.data_objects.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideDOConfirmDeleteModal"
                  qid="delete-data-object-cancel-button"
        >
          {{ $t('systems.data_objects.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteDO(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-data-objects-submit-button"
                  v-if="isGranted([permissions.SYSTEM_DATA_OBJECT_DELETE, permissions.SYSTEM_DATA_OBJECT_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
        >
          {{ $t('systems.data_objects.delete.submit') }}
        </b-button>
      </div>
    </b-modal>



    <!-- Add new data object -->
    <b-modal ref="add-data-object" hide-footer @hide="hideCreateDOModal">
      <div class="d-block text-center">
        <h4 qid="add-do-title">
          {{ $t('systems.data_objects.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-do-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="DOFormSubmit" qid="create-do-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-do-pg-label">
              {{ $t('systems.data_objects.create.do_label') }}
            </label>
            <multiselect
                v-model="selectedDO"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :options="DOItems"
                :placeholder="$t('systems.data_objects.create.do_placeholder')"
                label="name"
                @search-change="loadDO"
                track-by="slug"
                qid="create-do-form-do"
            ></multiselect>
          </b-form-group>
          <div v-if="selectedDO && selectedDO.description"
               class="text-center mb-3 mt-4"
          >
            <span class="cursor-pointer">
              <span class="mr-2"
                    @click="showDSDescription = !showDSDescription"
                    qid="data-objects-description-expand"
              >
                {{$t('systems.data_objects.create.do_description_expand')}}
              </span>
              <font-awesome-icon icon="chevron-down" v-if="!showDSDescription"/>
              <font-awesome-icon icon="chevron-up" v-if="showDSDescription"/>
            </span>
          </div>
          <div v-if="selectedDO && selectedDO.description && showDSDescription" class="mb-4 mt-2">
            <span class="text-formatted">
              {{ selectedDO.description }}
            </span>
          </div>

          <div v-if="selectedDO && selectedDO.classification">
            <label class="mt-3">
                {{ $t('maintenance.data_objects.create.classification_label') }}
            </label>
            <br>
            <span v-if="selectedDO">
              {{ selectedDO.classification }}
            </span>
          </div>
          <div v-if="selectedDO && selectedDO.business_classification">
            <label class="mt-3">
                {{ $t('maintenance.data_objects.create.business_classification_label') }}
            </label>
            <br>
            <span v-if="selectedDO">
              {{ selectedDO.business_classification }}
            </span>
          </div>
          <div v-if="selectedDO && selectedDO.category">
            <label class="mt-3">
              {{ $t('maintenance.data_objects.create.category_label') }}
            </label>
            <br>
            <span v-if="selectedDO">
              {{ selectedDO.category }}
            </span>
          </div>
          <div v-if="selectedDO && selectedDO.tags_translated && selectedDO.tags_translated.length" class="mb-3">
            <label class="mt-3">
              {{ $t('maintenance.data_objects.create.tags_label') }}
            </label>
            <br>
            <span class="mr-1" v-for="tag in selectedDO.tags_translated" qid="do-tags-list">
              <span class="badge badge-info mb-1" :title="tag.name_translated">
                {{tag.name_translated | truncate(35)}}
              </span>
            </span>
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateDOModal"
                    qid="create-lb-cancel-button"
          >
            {{ $t('systems.policies.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-lb-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.policies.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <DataViewModal
        :object="selectedDataObject"
        :showModal="viewDataModal"
        @closeViewModal="handleCloseViewDataModal"
    ></DataViewModal>

    <DataObjectActivitiesModal
        :object="selectedDataObject"
        :showModal="viewDataObjectActivitiesModal"
        :system="system"
        @closeViewModal="handleCloseViewDataObjectActivitiesModal"
        v-if="selectedDataObject"
    ></DataObjectActivitiesModal>


  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import DataViewModal from '@/views/ThirdParty/DataViewModal.vue';
  import DataObjectCreateForm from '@/views/DataObjects/DataObjectCreateForm.vue';
  import DataObjectActivitiesModal from '@/views/Systems/DataObjectActivitiesModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'DataObjectsTable',
    data: function() {
      return {

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        keywordValue: '',
        selectedDataObject: {},
        viewDataObjectActivitiesModal: false,
        selectedDataObjectActivities: [],
        selectedItem: {},
        showTagsModal: false,
        viewDataModal: false,
        selectedSort: '',
        selectedDirection: '',
        system: {},

        DOTableItems: [],
        DOLoading: false,
        DOItems: [],
        selectedDO: [],

        error: '',
        loadingItems: false,
        selectedDS: [],
        selectedDSSort: '',
        selectedDSDirection: '',
        acValidationShow: false,
        acTableItems: [],
        acLoading: true,
        dsItems: [],
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        showDSDescription: false,
        buttonDisabled: false,
        selectedDataSubject: {},
        viewDataSubjectModal: false,
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      DataViewModal,
      DataObjectCreateForm,
      DataObjectActivitiesModal,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadDataObjects()
      },
      object: function (value) {
        if (value && value.id) {
          this.system = value
          this.loadTasks('update_data_objects');
          this.loadDataObjects();
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.system.id && this.$store.state.updatedObject.who_am_i == this.system.who_am_i) {
              this.system = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_data_objects')
        }
      },
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadDataObjects()
      }, 400),
      reloadContent() {
        this.loadDataObjects();
        this.loadTasks('update_data_objects');
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadContent();
      },
      pageChanged(page) {
        this.loadDataObjects(page)
      },
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.system.who_am_i,
              model_id: this.system.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      handleCloseViewDataModal () {
        this.viewDataModal = false;
      },
      openViewDataModal(object) {
        this.selectedDataObject = object
        this.viewDataModal = true
      },
      perPageChanged(perPage) {
        let self = this;

        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
        // Load content when page changed listener is triggered
        this.loadDataObjects(1, perPage.value)
      },
      perPageRemoved() {
        let self = this;
        // Load content when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadDataObjects(1, self.selectedPerPage)
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'systems.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'System' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'System',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showCreateDOModal() {
        this.loadDO();
        this.$refs['add-data-object'].show()
      },
      hideCreateDOModal() {
        this.error = ''
        this.selectedDO = [];
        this.showDSDescription = false;
        this.$refs['add-data-object'].hide()
      },
      showDOConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-data-object'].show()
      },
      hideDOConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-data-object'].hide()
      },
      loadContent() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.system = response.data;
        }, function() {});
      },
      confirmDeleteDO(object) {
        let self = this;
        piincHttp.delete('systems/' + this.system.slug + '/data-objects/' + object.id).then(function() {
          self.hideDOConfirmDeleteModal();
          self.loadDataObjects();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('systems.data_objects.delete.success'))
        }, function() {});
      },
      openViewDataObjectActivitiesModal(object){
        this.selectedDataObject = object
        this.viewDataObjectActivitiesModal = true
      },
      handleCloseViewDataObjectActivitiesModal () {
        this.selectedDataObject = []
        this.viewDataObjectActivitiesModal = false;
      },
      DOFormSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedDO && this.selectedDO.id) {
          formData.append("data_object_id", this.selectedDO.id);
        }

        formData.append("system", this.system.slug);

        piincHttp.post('/systems/' + this.system.slug + '/data-objects', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('systems.data_objects.create.success'))
          self.hideCreateDOModal();
          self.buttonDisabled = false;
          self.loadDataObjects();
          self.loadContent();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.data_object_id) {
              self.error += ' ' + error.data.errors.data_object_id[0]
            }
          }
        })
      },
      // Table list
      loadDataObjects(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;

        piincHttp.get('systems/' + this.system.slug + '/data-objects', { params:
          {
            page: pageNumber,
            per_page: perPageNumber,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            keyword: this.keywordValue !== '' ? this.keywordValue : undefined,
            client: this.getClient.slug
          }
        }).then(function(response) {

          self.DOTableItems = response.data.items;
          self.DOLoading = false;
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {});

      },
      loadDO(query) {
        let self = this;
        piincHttp.get('data-objects', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.DOItems = response.data.items
          if (self.DOItems && !self.DOItems.length && !query) {
            self.DOItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
    },
    created () {
      this.system = this.object;
      if (this.getClient && this.getClient.slug) {
        this.loadDO();
      }
      if (this.system && this.system.id) {
        this.loadDataObjects();
        this.loadTasks('update_data_objects');
      }

      this.loadGuides('update_data_objects');
    }
  }
</script>
